<template>
	<div>
		<div id="app" ref="app" v-if="isService">
			<Header />
			<transition name="fade">
				<router-view
					:userPermission="userPermission"
					:license="license"
					:instituteId="$route.params.instituteId"
				></router-view>
			</transition>
			<migration-done
				v-if="isMigrationPopup"
				:data="migration"
				@hide="migration.isFirstVisit = false"
			></migration-done>
			<!-- width="calc(100%)" -->
			<notifications
				group="search"
				width="95%"
				position="bottom center"
				style="margin-bottom: 92px"
			>
				<template slot="body" slot-scope="props">
					<div
						class="vue-notification"
						:class="props.item.type"
						v-html="tt(props.item.text)"
					/>
				</template>
			</notifications>

			<notifications
				width="95%"
				position="bottom center"
				style="margin-bottom: 104px"
			>
				<template slot="body" slot-scope="props">
					<div
						class="vue-notification"
						:class="props.item.type"
						v-html="tt(props.item.text)"
					/>
				</template>
			</notifications>

			<portal-target name="lm-modal" multiple> </portal-target>
		</div>
		<div v-else>
			<!-- EOL은 임시이기 때문에 제거가 쉽도록 다음과 같이 구현 -->
			<ingPage
				v-if="migration.status === 'ING'"
				:data="migration"
			></ingPage>
			<available-page v-else></available-page>
		</div>
		<!--temp-->
		<!-- <pro-login></pro-login> -->
		<!-- <link-account></link-account> -->
		<!-- <change-pw></change-pw> -->
		<!-- <authentication-email></authentication-email> -->
		<!-- <sign-up></sign-up> -->
		<!-- <joined-account></joined-account> -->
	</div>
</template>

<script>
import Header from '@/views/app/AppHeader.vue'
import common, { setToken, getToken, goToSSOMain } from '@/utils/modules/Common'
import axiosInstance from '@/services/axiosConfig'
import { mapActions, mapMutations, mapState } from 'vuex'
import MixinData from '@/mixins/index.js'
import userAPI from './services/api/institute/user'
import PageName from './utils/defines/PageName'
// EOL
import migrationAPI from './services/api/eol/migration'

// EOL Page
import availablePage from '@/views/eol/available.vue'
import ingPage from '@/views/eol/ing.vue'

// EOL Components
import migrationDone from '@/views/eol/modals/migrationDone.vue'
//./EOL

export default {
	name: 'App',
	mixins: [MixinData],
	components: {
		Header,
		availablePage,
		ingPage,
		migrationDone,
	},
	data() {
		return {
			migration: {
				status: '',
				isFirstVisit: false,
			},
			isReload: false,
		}
	},
	async created() {
		this.offPinchZoom()
		this.offDoubleTabZoom()
		const queryToken = this.queryToken
		const token = queryToken ? queryToken : getToken()

		try {
			if (token) axiosInstance.setAuth(token)
			else {
				// 로그인 안되어있을때, 초대받기로 진입했을시 -> 초대받기 페이지 그대로 띄워주기
				if (location.href.includes('acceptInvite')) throw 'acceptInvite'
				else throw 'NO_TOKEN'
			}

			setToken(token)

			axiosInstance.loadGlobalFilter()

			const loginResponse = await this.loginUser()
			// console.log(loginResponse)
			// const isLoginError = loginResponse && loginResponse.msg === 'ERROR'
			// if (isLoginError) {
			// 	goToSSOMain()
			// }
			this.migration = (await migrationAPI.getMigrationStatus()).data

			await this.loadUserInfo()
			await this.loadUserInstituteInfo()
			await this.loadLicense()
			await this.loadUserPermission()

			// SSO 로그인 OR 회원가입시
			// 소규모 조직 생성 플로우에서 기관생성후 이전으로 갔을 때,
			// 새로고침 및 페이지 리로드시 대시보드로 이동
			if (
				queryToken ||
				this.$route.path === '/' ||
				(this.$route.path === '/createInstitution' && this.institute)
			) {
				this.$router.replace({
					name: PageName.Dashboard,
					params: {
						instituteId: this.institute.id,
					},
				})
			}
		} catch (error) {
			console.log(error)
			// TODO : 여기 분기 처리
			// createSmallInstitution
			if (error == 'acceptInvite') {
				return false
			} else if (error == 'NO_TOKEN') {
				goToSSOMain()
			} else if (error == 'EXPIRED') {
				this.$notify({
					type: 'common',
					text: this.tt(
						'라이선스가 만료되었습니다.<br>PC버전에서 라이선스를 갱신해주세요.'
					),
				})
				this.$router.push({
					name: 'InstitutionMain',
				})
			} else {
				if (error.status === 403) {
					this.$notify({
						type: 'common',
						text: this.tt(error?.data?.msg),
					})
					goToSSOMain()
				} else if (this.isService) {
					this.$router.replace({
						name: 'createInstitution',
					})
				}
			}
		}
	},
	mounted() {
		document.routeReplaceDashboard = () => {
			this.$router.replace({
				name: PageName.Dashboard,
				params: {
					instituteId: this.$route.params.instituteId,
				},
			})
		}
	},
	beforeDestroy() {
		document.routeReplaceDashboard = undefined
	},
	computed: {
		...mapState('user', ['institute', 'userPermission', 'license']),
		isService() {
			const queryToken = this.queryToken
			const token = queryToken ? queryToken : getToken()
			if (!token && location.href.includes('acceptInvite')) return true
			else return ['DONE', 'NEW', ''].indexOf(this.migration.status) >= 0
		},
		isMigrationPopup() {
			return (
				this.migration.status === 'DONE' && this.migration.isFirstVisit
			)
		},
		queryToken() {
			if (location.href.indexOf('token') >= 0) {
				const queryParams = {}

				location.href
					.split('?')[1]
					.split('&')
					.map(paramText => {
						paramText = paramText.split('=')
						queryParams[paramText[0]] = paramText[1]
					})

				return queryParams.token ? queryParams.token : ''
			} else {
				return ''
			}
		},
	},
	watch: {
		$route(to, from) {
			//TODO : 이후
			let toSplit = to.path.split('/')
			let fromSplit = from.path.split('/')

			if (toSplit[2] != fromSplit[2]) {
				this.setInitFilter()
			}

			if (location.href.includes('acceptInvite')) {
				return false
			}
			if (from.name) this.loadUserPermission()
			// if(this.$route.path.indexOf('inventory'))
			//     this.setInitFilter();
		},
	},
	methods: {
		...mapMutations('inventory', ['setInitFilter']),
		...mapMutations('user', ['setInstitute']),
		...mapActions('user', [
			'loadUserInfo',
			'loadUserInstituteInfo',
			'loadUserPermission',
			'lookupLicense',
			'loginUser',
		]),
		logout() {
			common.logout()
		},
		displayAppMenu() {
			console.log(this.displayPopup)
		},
		offPinchZoom() {
			// ref : https://jasonbla.tistory.com/13
			document.documentElement.addEventListener(
				'touchstart',
				function (event) {
					if (event.touches.length > 1) {
						event.preventDefault()
					}
				},
				false
			)
		},
		offDoubleTabZoom() {
			// ref : https://jasonbla.tistory.com/13
			var lastTouchEnd = 0
			document.documentElement.addEventListener(
				'touchend',
				function (event) {
					var now = new Date().getTime()
					if (now - lastTouchEnd <= 300) {
						event.preventDefault()
					}
					lastTouchEnd = now
				},
				false
			)
		},
		async loadLicense() {
			await this.lookupLicense(this.institute.id)
			if (this.license.status == 'EXPIRED') {
				throw 'EXPIRED'
			}
		},
	},
}
</script>

<style lang="scss">
#app {
	overflow-x: hidden;
}
* {
	/* Keyword values */
	user-select: none;

	/* Mozilla-specific values */
	-moz-user-select: none;

	/* WebKit-specific values */
	-webkit-user-select: text;
	/* Doesn't work in Safari; use only
    "none" or "text", or else it will
    allow typing in the <html> container */

	/* Microsoft-specific values */
	-ms-user-select: none;
}
// .fade-enter {
//     background-color: red;
//     // transform: translateX(50px);
//     transition: 0.5s;
//     position: fixed;
//     z-index: 1;
//     width: 100vw;
//     left: -50px;
// }

// .fade-enter-active {
//     transform: translateX(50px);
//     transition: 0.5s;
//     position: fixed;
//     z-index: 1;
//     width: 100vw;
//     left: -50px;
// }

// .fade-enter-to {
//     background-color: blue;
//     transform: translateX(-50px);
// }

// .fade-leave {
//     background-color: green;
//     transform: translateX(-50px);
// }

// .fade-leave-active {
//     background-color: black;
//     transform: translateX(-50px);
//     transition: 0.5s;
// }

// .fade-leave-to {
//     transition: 0.5s;
//     transform: translateX(-50px);
// }
</style>
